import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

navigationDrawerStyles.drawer = {
    size: 300,
    cssOverrides: {
        drawerContent: css`
            margin-top: -2px;
            overflow-x: hidden;
        `,
        drawerTitle: css`
            background: ${getColor("secondary")};
        `,
        titleButton: css`
            border: 2px solid ${getColor("secondary")};
            background: ${getColor("secondary")};
        `,
    },
};
navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &:first-child {
            margin-top: 0;
            padding-bottom: 10px;
            background: ${getColor("secondary")};
            font-size: ${TYPOGRAPHY.size.small};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
        }
        &:last-child {
            margin-bottom: 5px;
            margin-top: 0;
        }
        margin-top: 20px;
    `,
};
navigationDrawerStyles.panelMenu = {
    cssOverrides: {
        wrapper: css`
            > button {
                span {
                    font-size: ${TYPOGRAPHY.size.small};
                    font-weight: ${TYPOGRAPHY.weight.baseBold};
                }
            }
            > div {
                > div:first-child {
                    background: ${getColor("secondary")};
                    button {
                        background: ${getColor("secondary")};
                        border: 2px solid ${getColor("secondary")};
                        span {
                            color: ${COLORS.white};
                        }
                    }
                }
                div:last-child {
                    a {
                        span {
                            font-size: ${TYPOGRAPHY.size.small};
                            font-weight: ${TYPOGRAPHY.weight.baseBold};
                            color: ${COLORS.black} !important;
                        }
                    }
                }
            }
        `,
    },
};
navigationDrawerStyles.mainNavigationRow = {
    color: "common.backgroundContrast",
    css: css`
        margin: 2px;
        background: ${getColor("secondary")};
        span {
            font-size: ${TYPOGRAPHY.size.small};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
        }
    `,
};
navigationDrawerStyles.userRowTypography = {
    css: css`
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
};
